<script setup lang="ts">
/* eslint-disable vue/valid-template-root -- renderless component: the empty
   template is deliberate (dropping it entirely would leave the SFC without a
   render function and warn at runtime). */
/**
 * Mount inside a SectionNavRoot that owns the sections. Feeds the
 * observer-free registry so scrubbers / function rails track scroll.
 * Soft-fails (no throw) when the registry is missing so a layout glitch
 * never blanks the whole page.
 */
import { computed, inject } from 'vue';
import { sectionNavRegistryKey } from './internal';
import { useSectionScrollSpy } from './useSectionScrollSpy';

const registry = inject(sectionNavRegistryKey, null);
if (registry) {
  useSectionScrollSpy({
    items: computed(() =>
      registry.items.value.map(({ id, el }) => ({ id, el: el as HTMLElement }))
    ),
    setActive: (id) => registry.setActive(id),
    // Rail/section clicks set the registry's active id directly; the spy uses
    // this to freeze while the resulting smooth scroll is in flight.
    activeId: computed(() => registry.activeId.value),
  });
} else if (import.meta.env?.DEV) {
  console.warn('[nx-ui] NxSectionNavScrollSpy mounted outside SectionNavRoot — no-op');
}
</script>

<template></template>
